import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ClientUserService, ProUserService } from '../../services';

/* eslint-disable */
export const loggedOutOnlyGuard: CanActivateFn = (route, state) => {
    const clientUser = inject(ClientUserService).user();
    const proUser = inject(ProUserService).user();

    //If user is logged in and tried to access the screen meant for a logged out user, redirect them to the home screen
    if (clientUser || proUser) {
        inject(Router).navigateByUrl('/');
        return false;
    } else {
        return true;
    }
};
